module.exports = __webpack_public_path__ + "img/gallery.3267acc7.svg";